import { ReactNode } from "react";
import { InputSize, Select } from "shared/components";
import { CheckCircleBroken } from "untitledui-js-base";
import { PaymentStatuses } from "../constants";

export const SelectPayment = ({
  handleChange,
  value,
  options,
  id
}: {
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string | number;
  options?: { value: string | number; label: JSX.Element }[];
  id: string;
}) => {
  return (
    <Select
      id={id}
      menuPortalTarget={document.body}
      options={
        options?.length
          ? [...defaultPaymentOptions, ...options]
          : defaultPaymentOptions
      }
      className="w-[183px] !mb-0"
      value={value}
      onChange={handleChange}
      searchable={false}
      size={InputSize.SM}
    />
  );
};

export const Label = ({
  icon,
  title
}: {
  title: ReactNode;
  icon?: ReactNode;
}) => {
  return (
    <div className="flex gap-2 items-center">
      {icon ? icon : null}
      {typeof title === "string" ? (
        <p className="text-content-1000 font-medium text-sm">{title}</p>
      ) : (
        title
      )}
    </div>
  );
};

const defaultPaymentOptions = [
  {
    value: PaymentStatuses.NO_DATA,
    label: (
      <Label
        title="No data"
        icon={<div className="border border-content-100 w-4" />}
      />
    )
  },
  {
    value: PaymentStatuses.PAID_ON_TIME,
    label: (
      <Label
        title="Paid on-time"
        icon={<CheckCircleBroken size="16" className="stroke-success-700" />}
      />
    )
  }
];
